import styled from "styled-components";

export const TableContainer = styled.table`
  height: fit-content;
  border-collapse: collapse;
  width: 100%;

  tr, td, th {
    border-bottom: 1px solid ${({theme}) => theme.grayDivider};
  }

  td, th {
    padding: 26px 32px;
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      padding: 13px 16px;
    }
  }

  .md-hide {
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      display: none;
    }
  }

  .lg-hide {
    @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
      display: none;
    }
  }
  .xxl-hide {
    @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
      display: none;
    }
  }
`

interface TableRowProps {
    clickable?: Boolean
}

export const TableRow = styled.tr<TableRowProps>`
  height: fit-content;
  transition: all 0.5s;

  :hover {
    cursor: ${({clickable}) => clickable ? 'pointer' : 'default'};
    background: ${({clickable}) => clickable ? ({theme}) => theme.grayBackground : 'white'};
  }
`

interface TableRowProps {
    alignment?: string;
}

export const TableHeaderCell = styled.td<TableRowProps>`
  height: 100%;
  font-weight: 700;
  color: ${({theme}) => theme.gray};
  font-size: 14px;
  text-align: ${({alignment}) => alignment ? alignment : 'left'};
`

export const TableDataCell = styled.td`
  height: 100%;
`

export const TablePrimaryText = styled.p`
  color: ${({theme}) => theme.accent};
  font-weight: 500;
  font-size: 14px;
`

export const TableSecondaryText = styled.p`
  color: ${({theme}) => theme.grayDark};
  font-weight: 400;
  font-size: 12px;
`

export const TableSpanText = styled.span`
  color: ${({theme}) => theme.grayLight};
  font-weight: 400;
  font-size: 12px;
`


